import { render, staticRenderFns } from "./AddContentDialog.vue?vue&type=template&id=03a79e5c&scoped=true"
import script from "./AddContentDialog.vue?vue&type=script&lang=js"
export * from "./AddContentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddContentDialog.vue?vue&type=style&index=0&id=03a79e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a79e5c",
  null
  
)

export default component.exports